import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import Image from 'components/Common/Image'

export const LeadersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding-bottom: ${rem(48)};
`

export const LeaderWrapper = styled.div`
  padding: 0 ${rem(8)};
  flex-basis: 50%;
  margin-top: ${rem(48)};
  text-align: center;

  ${mediaQueryUp.tablet} {
    flex-basis: 25%;
  }
`

export const LeaderStyledImage = styled(Image)`
  margin-bottom: ${rem(16)};
  border-radius: 999px;
`
